import { useEffect } from 'react'
import { applyHead } from '../utils/head'

/** Aplica títulos, metadatos, datos estructurados y precargas una sola vez. */
export function useHead(): void {
  useEffect(() => {
    applyHead()
  }, [])
}
